<template>
  <div class="overflow-auto">
    <div
      class="w-100 d-flex justify-content-around p-2 border-bottom sticky-top align-items-center"
      style="background: rgb(244, 245, 247); height: 70px; z-index: 20;"
    >
      <div
        class="d-flex flex-column text-center"
        :class="{ 'navigate-element': active > 0, 'active-element': active === 0 }"
        @click="onNavigate(0, $routeNames.CHECKOUT_TYPE_PAGE_ROUTE)"
      >
        <i class="el-icon-s-order" />
        <span>{{ $t('checkout.type') }}</span>
      </div>
      <div
        class="d-flex flex-column text-center"
        :class="{ 'navigate-element': active > 1, 'active-element': active === 1 }"
        @click="onNavigate(2, $routeNames.CHECKOUT_DETAILS_PAGE_ROUTE)"
      >
        <i class="el-icon-s-operation" />
        <span>{{ $t('checkout.details') }}</span>
      </div>
      <div
        class="d-flex flex-column text-center"
        :class="{ 'navigate-element': active > 2, 'active-element': active === 2 }"
        @click="onNavigate(2, $routeNames.CHECKOUT_SUMMARY_PAGE_ROUTE)"
      >
        <i class="el-icon-view" />
        <span>{{ $t('checkout.summary') }}</span>
      </div>
    </div>
    <router-view class="mt-2" />
  </div>
</template>

<script>
export default {
  name: 'CheckoutMainPage',
  components: {},
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    active() {
      if (this.$route.name === this.$routeNames.CHECKOUT_TYPE_PAGE_ROUTE) {
        return 0;
      }
      if (this.$route.name === this.$routeNames.CHECKOUT_DETAILS_PAGE_ROUTE) {
        return 1;
      }
      if (this.$route.name === this.$routeNames.CHECKOUT_SUMMARY_PAGE_ROUTE) {
        return 2;
      }

      return 0;
    },
  },
  methods: {
    onNavigate(index, routeName) {
      if (index <= this.active) {
        this.$router.replace({ name: routeName });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navigate-element {
  &:hover {
    span {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}

.active-element {
  font-weight: bold;
}
</style>
